<template>
  <div class="mm-page-main" v-loading="loading">
    <div class="table-box">
      <div class="table-header mb15" style="flex-wrap:wrap">
        <div>
          <el-radio-group v-model="form.area" @change="getdata">
            <el-radio-button label="-1">全部</el-radio-button>
            <el-radio-button label="0">港幣</el-radio-button>
            <el-radio-button label="1">人民幣</el-radio-button>
            <el-radio-button label="2">外幣</el-radio-button>
          </el-radio-group>
        </div>
        <div class="mt10 mb10">
        </div>
      </div>
      <div class="table-body">
        <el-table :data="currencydata" border style="width: 100%" :header-cell-style="{background:'#fafafa'}">
          <!-- <el-table-column prop="area" label="地區" width="90">
            <template slot-scope="scope">
              <div class="phonecel">地區</div>
              {{scope.row.area==0?'香港':(scope.row.area==1?'中國':'海外')}}
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="short_name" :label="$t('货币')" >
            <template slot-scope="scope">
              <div class="img-text-box">
                <img class="currency-icon" :src="scope.row.thumb" alt="">
                <span>{{scope.row.currency_short_name}}</span>
              </div>
            </template>
          </el-table-column> -->

          <el-table-column prop="bankname" label="銀行賬號" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">銀行賬號</div>
              <div class="mm-text-right">
                <div class="img-text-box" style="padding:5px;">
                  <img class="currency-icon" :src="scope.row.thumb" style="height:20px;width:20px;">
                  <span>{{scope.row.currency_short_name}}</span>
                </div>
                <div style="padding:5px;">{{scope.row.bankinfo!=''?scope.row.bankinfo:scope.row.bankname}}</div>
                <div style="padding:5px;">{{scope.row.account_name}}</div>
                <div style="padding:5px;">{{addSpace(scope.row.account_num)}}</div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="status" label="狀態" align="center" sortable>
            <template slot-scope="scope">
              <div class="phonecel">狀態</div>
              <el-switch disabled="" v-model="scope.row.status" active-text="啟用" inactive-text="禁用"></el-switch>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="account_num" label="賬號號碼" align="center" sortable ></el-table-column> -->
          <!-- <el-table-column prop="account_name" label="賬戶持有人" align="center" sortable ></el-table-column> -->
          <el-table-column prop="money" label="貨幣結餘" sortable>
            <template slot-scope="scope">
              <div class="phonecel">貨幣結餘</div>
              <div>
                <span class="mr10">{{tomoney(scope.row.money)}}</span>
                <span> {{scope.row.currency_short_name}}</span>
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="costrate" label="成本" width="90" >
            <template slot-scope="scope">
              <span>{{scope.row.costrate}}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="hkd" label="折合港幣" sortable>
            <template slot-scope="scope">
              <div class="phonecel">折合港幣</div>
              <span>{{tomoney(scope.row.hkd)}} HKD</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="tabletotal">
          <span>總結</span>
          <span>{{tomoney(surplus_hkd_total)}} HKD</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customer_id: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      surplus_hkd_total: 0.00,
      addbox: false,
      value: '',
      submitStatus: false,
      loading: true,
      form: {
        area: -1
      },
      currencydata: [
      ],
    };
  },
  methods: {
    goByUrl (routerName, id = 0) {
      this.$router.push({
        name: routerName,
        params: {
          id: id
        }
      })
    },
    getdata () {
      let area = this.form.area;
      let store_id = this.sessionRead('store_id');
      let mso_id = this.sessionRead('mso_id');
      let customer_id = this.customer_id;
      this.post('/api/bank/getcustomerbalance', { store_id, area, mso_id, gettype: 1, customer_id })
        .then(response => {
          if (response.length > 0) {
            let total = 0;
            this.currencydata = response.map(item => {
              item.thumb = this.apiurl + item.currency_thumb;
              if (item.status == 0) {
                item.status = true;
              } else if (item.status == 1) {
                item.status = false;
              }
              item.account_num_format = this.addSpace(item.account_num);

              total += item.hkd;
              this.surplus_hkd_total = parseFloat(total).toFixed(2);
              return item;
            })
          } else {
            this.currencydata = [];
            this.surplus_hkd_total = parseFloat(0).toFixed(2)
          }
          this.loading = false;
        })
        .catch(error => {
          this.currencydata = [];
          console.log(error);
          this.loading = false;
        });
    },
  },
  created () {
    this.getdata();
  }
}
</script>

<style scoped>
.mb15 {
  margin-bottom: 15px;
}
.tabletotal {
  background-color: #fafafa;
  padding: 10px;
  border: 1px solid #ebeef5;
  border-top: none;
  display: flex;
  justify-content: space-between;
}
</style>